export default "__VITE_ASSET__DUo4y1zf__"